import {
  InvestmentFrequency,
  Portfolio,
  SelfDirectedPortfolio,
} from 'generated/types'
import { PortfolioType } from 'pages/portfolio/types'

export const hasCustomPortfolio = (
  portfolios: Array<Portfolio | SelfDirectedPortfolio>,
) => {
  return portfolios?.some(
    (portfolio) => portfolio.__typename === PortfolioType.SELF_DIRECTED,
  )
}

// @note: This is to handle our fractional percentages (introduced with the crypto work)
// If a percentage is "19.8%" for example, we want to display it as such. If it's a whole
// number, we don't want to show the decimal values.
export const getFormattedDecimalPercentage = (
  value: number,
  isDecimalPercentage = true,
) =>
  `${(isDecimalPercentage ? value * 100 : value)?.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`

export const getInvestmentFrequency = (freq: string): InvestmentFrequency => {
  let frequency = InvestmentFrequency.Daily
  if (freq === InvestmentFrequency.Weekly) {
    frequency = InvestmentFrequency.Weekly
  } else if (freq === InvestmentFrequency.Monthly) {
    frequency = InvestmentFrequency.Monthly
  }
  return frequency
}
